import { Navigate } from "react-router";

/** Thin redirect — the spreken home folded into the unified /oefenen hub.
 *  Kept alive so old bookmarks/deep-links resolve. */
export function HomePage() {
  return <Navigate to="/oefenen?module=spreken" replace />;
}
